(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _hamburger = _interopRequireDefault(require("./modules/hamburger.js"));
var _filter = _interopRequireDefault(require("./modules/filter.js"));
var _leesMeer = _interopRequireDefault(require("./modules/lees-meer.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Import JS classes

// Initiate JS classes
var hamburger = new _hamburger["default"]();
var filtrs = new _filter["default"]();
var lsmr = new _leesMeer["default"]();

},{"./modules/filter.js":2,"./modules/hamburger.js":3,"./modules/lees-meer.js":4}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* JavaScript toggle Filter */
var Filters = /*#__PURE__*/function () {
  function Filters() {
    _classCallCheck(this, Filters);
    if (document.body.classList.contains('page-template-aanbod')) {
      this.events();
    }
  }
  return _createClass(Filters, [{
    key: "events",
    value: function events() {
      var filterButton = document.querySelector('.filter-box button.filterknop');
      filterButton.addEventListener('click', this.toggleFilters.bind(this));
    }
  }, {
    key: "toggleFilters",
    value: function toggleFilters() {
      var filters = document.querySelector('.filter-box .filters');
      var filterButton = document.querySelector('.filter-box button.filterknop');
      if (!filters.classList.contains('open')) {
        filters.style.left = '0';
        filters.classList.add('open');
        filterButton.innerHTML = '<i class="fa-solid fa-x"></i> Filter Sluiten';
      } else {
        filters.classList.remove('open');
        filters.style.left = '-100%';
        filterButton.innerHTML = '<i class="fa-solid fa-filter"></i> Filteren';
      }
    }
  }]);
}();
var _default = exports["default"] = Filters;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* JavaScript Hamburger Menu */
var HamburgerMenu = /*#__PURE__*/function () {
  function HamburgerMenu() {
    _classCallCheck(this, HamburgerMenu);
    this.events();
  }
  return _createClass(HamburgerMenu, [{
    key: "events",
    value: function events() {
      var burgerButton = document.getElementById('toggle-menu-button');
      burgerButton.addEventListener('click', this.toggleHamburgerMenu);
    }
  }, {
    key: "toggleHamburgerMenu",
    value: function toggleHamburgerMenu(event) {
      var overlay = document.querySelector('.mobile-menu-container');
      var burgerButton = document.querySelector('#toggle-menu-button i');
      if (!overlay.classList.contains('open')) {
        burgerButton.style.color = "#000000";
        overlay.style.opacity = '1';
        overlay.style.pointerEvents = 'all';
        overlay.classList.add('open');
      } else {
        burgerButton.style.color = "#00811F";
        overlay.style.opacity = '0';
        overlay.style.pointerEvents = 'none';
        overlay.classList.remove('open');
      }
    }
  }]);
}();
var _default = exports["default"] = HamburgerMenu;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* JavaScript toggle Filter */
var leesMeer = /*#__PURE__*/function () {
  function leesMeer() {
    _classCallCheck(this, leesMeer);
    if (document.body.classList.contains('page-template-aanbod')) {
      this.events();
    }
  }
  return _createClass(leesMeer, [{
    key: "events",
    value: function events() {
      var _this = this;
      var leesMeerButtons = document.querySelectorAll('.onderneming .lees-meer');
      leesMeerButtons.forEach(function (element) {
        element.addEventListener('click', _this.toggleFilters);
      });
    }
  }, {
    key: "toggleFilters",
    value: function toggleFilters(event) {
      var leesMeerButton = event.target;
      var parent = event.target.parentNode;
      var content = parent.querySelector(".content");
      if (!content.classList.contains('clamped')) {
        content.classList.add('clamped');
        leesMeerButton.innerHTML = "Lees meer >";
      } else {
        content.classList.remove('clamped');
        leesMeerButton.innerHTML = "Lees minder >";
      }
    }
  }]);
}();
var _default = exports["default"] = leesMeer;

},{}]},{},[1]);
